import React from "react";

function ResetIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M15.34.66l-1.684 1.684A7.973 7.973 0 008 0C3.592 0-.003 3.598 0 8.006a8 8 0 0013.36 5.932.388.388 0 00.016-.562l-.637-.637a.388.388 0 00-.532-.017A6.3 6.3 0 018 14.322 6.32 6.32 0 011.677 8 6.32 6.32 0 018 1.677c1.747 0 3.328.708 4.471 1.852l-1.746 1.746a.387.387 0 00.274.66h4.614A.387.387 0 0016 5.548V.935a.387.387 0 00-.66-.274z"></path>
        </g>
      </g>
    </svg>
  );
}

export default ResetIcon;
